import React from "react";
import ProTypes from "prop-types";

import SelectMotif from "./select-motif";
import SelectPosition from "./select-position";
import SelectModele from "./select-modele";
import Trash from "./trash";
import Download from "./download";
import Compare from "./compare";
import Contact from "./contact";

const Navbar = ({ title }) => (
  <nav className="navbar navbar-inverse navbar-fixed-top">
    <div className="container">
      <div className="navbar-header">
        <button
          type="button"
          className="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#navbarmobile"
          aria-expanded="false"
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </button>
        <a className="navbar-brand" href="#">
          {title}
        </a>
      </div>
      <div className="collapse navbar-collapse" id="navbarmobile">
        <div className="nav navbar-nav navbar-inner navbar-right form-inline">
          <Compare /> <Download /> <Trash /> <SelectModele /> <SelectPosition />{" "}
          <SelectMotif />{" "}
          <a
            className="btn btn-warning navbar-btn"
            href="../rsqgenerateur"
            title="Générateur"
          >
            <span className="glyphicon glyphicon-edit" />
          </a>{" "}
          <a
            className="btn btn-default navbar-btn"
            href=".."
            title="MiCetF (Accueil)"
          >
            <span className="glyphicon glyphicon-home" />
          </a>{" "}
          <Contact who="webmaster" where="micetf.fr" />
        </div>
      </div>
    </div>
  </nav>
);

Navbar.propTypes = {
  title: ProTypes.string.isRequired
};
export default Navbar;
